exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".overlay{position:fixed;z-index:900;top:0;right:0;bottom:0;left:0;background-color:hsla(0,0%,77%,.85)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/home/vintagp/www/toyota_dreamcar/front/assets","/static":"/home/vintagp/www/toyota_dreamcar/front/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-4028fd50","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/sass-resources-loader/lib/loader.js?{"resources":["/home/vintagp/www/toyota_dreamcar/front/assets/scss/util/_mixins.scss","/home/vintagp/www/toyota_dreamcar/front/assets/scss/util/_functions.scss","/home/vintagp/www/toyota_dreamcar/front/assets/scss/util/_variables.scss"]}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./components/_UI/BaseOverlay.vue
// module id = O6+a
// module chunks = 13